module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"downForMaintenance":{"header":"Under Maintenance","body":"Our home insurance service will be down for maintenance from {time}. We apologise for any inconvenience."}}}')
  delete Component.options._Ctor
}
